// Bridge Event Types
export enum BridgeEvent {
  openDialog = 'openDialog',
  getImage = 'getImage',
  getAccessToken = 'getAccessToken',
}

export type BridgeEventType = keyof typeof BridgeEvent;

// Base Bridge Types
export interface BridgeCallback {
  onSuccess?: string;
  onError?: string;
}

export interface BridgeRequest<T = any> {
  name: string;
  data?: T;
}

// Specific Bridge Request Types
export interface OpenUrl {
  url: string;
  target?: '_blank' | '_self';
}

export interface OpenDialogRequest {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'alert' | 'confirm' | 'prompt';
}

export interface SetMainTabBarVisibility {
  visible: boolean;
  animated?: boolean;
}

export interface GetImage {
  allowMultiple?: boolean;
  quality?: number;
  maxWidth?: number;
  maxHeight?: number;
  source?: 'camera' | 'gallery' | 'both';
}

export interface GetAccessToken {
  refreshIfExpired?: boolean;
  scopes?: string[];
}

export interface SetHistoryBackBlock {
  blocked: boolean;
  message?: string;
}

export interface EventLogging {
  event: string;
  parameters?: Record<string, any>;
  userId?: string;
}

// Environment Types
export enum EnvType {
  DEV = 'development',
  STAGING = 'staging',
  PROD = 'production',
}

// Access Token Response Types
export enum AccessTokenResponseType {
  SUCCESS = 'success',
  ERROR = 'error',
  CANCELLED = 'cancelled',
}

// WebView Message Types
export interface WebViewMessage {
  type: string;
  data?: any;
  requestId?: string;
}

// Native Module Response Types
export interface NativeResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  requestId?: string;
}

// Bridge Handler Types
export type BridgeHandler<T = any> = (data: T) => Promise<any> | any;

export interface BridgeHandlers {
  openUrl: BridgeHandler<OpenUrl>;
  goBack: BridgeHandler;
  reload: BridgeHandler;
  openDialog: BridgeHandler<OpenDialogRequest>;
  setMainTabBarVisibility: BridgeHandler<SetMainTabBarVisibility>;
  getImage: BridgeHandler<GetImage>;
  getAccessToken: BridgeHandler<GetAccessToken>;
  setHistoryBackBlock: BridgeHandler<SetHistoryBackBlock>;
  openLoginDialog: BridgeHandler;
  eventLogging: BridgeHandler<EventLogging>;
}
